<template>
  <router-view />
  <BaseNotifications />
  <TheCssBreakpointDetector />
</template>

<script setup lang="tsx">
import { useRoute } from "vue-router";
import { BaseNotifications } from "@modernary/mui/components/notifications";
import { useAppNav, TheCssBreakpointDetector } from "@modernary/mui/components/common";
import { routeNames } from "@/routes";

const route = useRoute();
const { setNavigationItems, setApplicationTitleComponent } = useAppNav();

const titleComponent = () => <div>Connect</div>;
setApplicationTitleComponent(titleComponent);

// Nav items should be set one time during app initilization / config.
setNavigationItems([
  {
    label: "home",
    className: "",
    showLabel: false,
    items: [
      { label: "Home", name: routeNames.home },
      { label: "Map", name: routeNames.map },
    ],
  },
]);
</script>
